import type { TFunction } from 'i18next'
import { z } from 'zod'

import { BidIdSchema } from '@mntn-dev/domain-types'
import type { ZodInfer } from '@mntn-dev/utility-types'

export const AcceptBidFormValidationSchema = (
  t: TFunction<'bids'>,
  isCreditProgramProject: boolean
) =>
  z.object({
    bidId: BidIdSchema,
    termsAccepted: z.boolean().refine((value) => value, {
      message: t('terms-required-error', { ns: 'bids' }),
    }),
    // required for credit program projects. for other projects the credit terms
    // checkbox won't be shown so set it to optional
    creditTermsAccepted: isCreditProgramProject
      ? z.boolean().refine((value) => value, {
          message: t('credit-terms-required-error', { ns: 'bids' }),
        })
      : z.boolean().optional(),
  })

export type AcceptBidFormModel = ZodInfer<
  ReturnType<typeof AcceptBidFormValidationSchema>
>
